import { render, staticRenderFns } from "./GlLevel1CheckersQueueInfoModal.vue?vue&type=template&id=a08545b8&scoped=true&"
import script from "./GlLevel1CheckersQueueInfoModal.vue?vue&type=script&lang=js&"
export * from "./GlLevel1CheckersQueueInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./GlLevel1CheckersQueueInfoModal.vue?vue&type=style&index=0&id=a08545b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08545b8",
  null
  
)

export default component.exports